import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { jwtDecode } from 'jwt-decode';
import { setAuthToken } from '../api/auth';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    // Remove any existing token to force login on every page load
    localStorage.removeItem('token');
    setAuthToken(null);
    return null;
  });

  const login = useCallback((token) => {
    localStorage.setItem('token', token);
    setAuthToken(token);
    const decoded = jwtDecode(token);
    // Ensure we have consistent user id property
    const userData = {
      ...decoded,
      id: decoded.id || decoded.user_id || decoded.sub, // Try common JWT user id fields
      token
    };
    setUser(userData);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('token');
    setAuthToken(null);
    setUser(null);
  }, []);

  // Optionally, refresh token logic can be added here.
  useEffect(() => {
    // Example: auto-logout on token expiry (simple client-side check)
    if (user && user.exp) {
      const expMs = user.exp * 1000 - Date.now();
      const id = setTimeout(logout, expMs);
      return () => clearTimeout(id);
    }
  }, [user, logout]);

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);